<template>
    <div>
        <HeaderStock header="ตั้งค่าข้อมูลเกี่ยวกับคลัง" :img_header="header_image" link_back="stock" />
        <MenuStockSetting/>
        <StockZoneList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock-setting.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockSetting from '@/components/menuadmin/stock/stocksetting/MenuStockSetting.vue'
import StockZoneList from '@/components/menuadmin/stock/stocksetting/StockZoneList.vue'
export default {
    name:'stockZone',
    components:{
        HeaderStock,
        MenuStockSetting,
        StockZoneList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>